import React from "react";
import { site } from "../generated/content";
import { useLanguage } from "../context/LanguageContext";
import "../style/AboutUs.css";

export default function AboutUs() {
  const { t } = useLanguage();
  const title = t(site.about.title);

  // The source text separates paragraphs with blank lines. Splitting them into
  // real <p> elements gives proper spacing instead of one dense block.
  const paragraphs = t(site.about.body)
    .split(/\n\s*\n|\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <section className="about" aria-labelledby="about-title">
      <div className="about__inner">
        <h2 id="about-title" className="section-title">
          {title}
        </h2>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
